import React from 'react'
import DeskDashboard from '../Components/DeskDashboard'
import { AML_STAGE_LABEL, ESCALATED_KEY } from '../../lib/makerCheckerQueues'

const AML_OFFICER = ['CAN_OMM_AML_OFFICER']
const NEED_ACTION_WHITELIST = [
  'CAN_OMM_AML_OFFICER',
  'CAN_OMM_NEW_BUSINESS',
  'CAN_OMM_AGENT_BRANCH',
  'CAN_OMM_AML_MANAGEMENT',
]

// No date window — an approval queue must not drop policies as they age.
function tabs() {
  return [
    {
      key: 'awaiting',
      authorities: AML_OFFICER,
      label: 'Awaiting Review',
      params: {
        status: 'Un_Confirmed',
        maker_check_label: AML_STAGE_LABEL,
        maker_check_status: 'Pending',
        additional_details: {
          aml_need_action: false
        }
      },
      emptyMessage: 'No policies awaiting AML review.',
      showAmlFlag: true,
      showStage: true
    },
    {
      key: 'escalated',
      authorities: AML_OFFICER,
      label: 'Escalated',
      params: {
        status: 'Un_Confirmed',
        additional_details: { [ESCALATED_KEY]: true }
      },
      emptyMessage: 'No policies are with Senior Management.',
      showAmlFlag: true
    },
    {
      // Rejected AT the AML stage, by the desk or by Senior Management — both
      // decide this same check. A New Business rejection leaves the AML stage
      // Approved, so it cannot match here. Keyed on the AML stage rather than
      // on "some check is Rejected" because rejecting one stage voids every
      // remaining Pending sibling as Rejected too.
      key: 'rejected',
      authorities: AML_OFFICER,
      label: 'Rejected',
      params: {
        status: 'Rejected',
        maker_check_label: AML_STAGE_LABEL,
        maker_check_status: 'Rejected'
      },
      emptyMessage: 'No policies rejected by the AML Desk.',
      showAmlFlag: true
    },
    {
      key: 'need_action',
      authorities: NEED_ACTION_WHITELIST,
      label: 'Need Action',
      params: {
        status: 'Un_Confirmed',
        maker_check_label: AML_STAGE_LABEL,
        maker_check_status: 'Pending',
        additional_details: {
          aml_need_action: true
        }
      },
      emptyMessage: 'No policies that need action under AML Desk.',
      showAmlFlag: true
    },
    {
      // Policies currently awaiting AML re-review after being returned from a
      // later stage. Server returns the same Un_Confirmed/AML-Pending bucket as
      // Awaiting Review; the client-side filter narrows to those that also carry
      // at least one Returned check row (the audit record of the return action).
      key: 'returned',
      authorities: NEED_ACTION_WHITELIST,
      label: 'Returned',
      params: {
        status: 'Un_Confirmed',
        maker_check_label: AML_STAGE_LABEL,
        maker_check_status: 'Returned'
      },
      emptyMessage: 'No policies have been returned to the AML stage.',
      showAmlFlag: true,
      showStage: true
    }
  ]
}

const AmlDeskDashboard = props => (
  <DeskDashboard {...props} title="AML Desk" tabs={tabs()} />
)

export default AmlDeskDashboard
